import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import { getHomeCouponMeta } from 'lib/couponPage';

const CouponsHead = ({ activeCoupons, featuredStores }) => {
  const { title, description } = getHomeCouponMeta({
    activeCoupons,
    featuredStores,
  });

  return (
    <NextSeo
      description={description}
      openGraph={{ title, description }}
      title={title}
    />
  );
};

CouponsHead.propTypes = {
  activeCoupons: PropTypes.arrayOf(
    PropTypes.shape({
      couponDiscountValue: PropTypes.string.isRequired,
    })
  ).isRequired,
  featuredStores: PropTypes.arrayOf(
    PropTypes.shape({
      storeName: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default CouponsHead;
